import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';
const api = {
  key: "91345961d4cdcc6208d80d712e50f7ca",
  base: "https://api.openweathermap.org/data/2.5/" 
}

function App() {

  const [query, setQuery] = useState('');
  const [weather, setWeather] = useState({});

  const search = evt => {
    if (evt.key === "Enter") {
      fetch(`${api.base}weather?q=${query}&units=metric&APPID=${api.key}`)
        .then(res => res.json())
        .then(result => {
          setWeather(result);
          setQuery('');
          console.log(result);
        });
    }
  }

  const dateBuilder = (d) => {
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    let day = days[d.getDay()];
    let date = d.getDate();
    let month = months[d.getMonth()];
    let year = d.getFullYear();

    return `${day} ${date} ${month} ${year}`
  }

  return (
    <div className="App">
<main>
  <div className="search-box">
    <input 
    type="text"
    className="search-bar"
    placeholder="Search..."
    onChange={e => setQuery(e.target.value)}
    value={query}
    onKeyPress={search}
    />
  </div>
  {(typeof weather.main != "undefined") ? (
    <div id="info-weather-text">
  <div className="location-box">
    <div className="location">{weather.name}, {weather.sys.country}</div>
    <div className="date">{dateBuilder(new Date())}</div>
  </div>
  <div className="weather-box">
    <div className="temp">
   Currently is  {Math.round(weather.main.temp)}°c
    </div>
    <div className="weather">And the weather is {weather.weather[0].main}</div>
  </div>


  </div>
  ) : ('')}

<div className="description">
  <p>This Weather App , have been made in react and openweather api</p>
  <p>How it works? Just search a city or a country via the search box!</p>
</div>


</main>
    </div>



  );
}

export default App;
